import { SessionStore } from './session.store';
import { AggregateFunction, AgtAnalyticsStore } from './agt.analytics.store';

export interface IAgtLeadNowConsecutiveModel {
	vtnrId: number;
	firstKw: number;
	lastKw: number;
	consecutiveCount: number;


}

export class AgtLeadNowConsecutiveModel implements IAgtLeadNowConsecutiveModel {
	vtnrId: number;
	firstKw: number;
	lastKw: number;
	consecutiveCount: number;

	constructor(data: any) {
		this.vtnrId = data.aid || 0;
		this.firstKw = data.first || 0;
		this.lastKw = data.last || 0;
		this.consecutiveCount = data.cc || 0;

	}
}

export class AgtLeadConsecutiveStoreNowStore extends AgtAnalyticsStore {
	constructor(session: SessionStore) {
		super(session, {
			tableName: 'v_agentur_leadnow_max_consecutive',
			defaultColumns: [
				{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE, alias: 'aid' },
				{ column: 'first_kw', aggregateFunction: AggregateFunction.NONE, alias: 'first' },
				{ column: 'last_kw', aggregateFunction: AggregateFunction.NONE, alias: 'last' },
				{ column: 'consecutive_count', aggregateFunction: AggregateFunction.NONE, alias: 'cc' },
			],
		});
		this.queryName = '?v_agentur_leadnow_max_consecutive';
	}

	async loadForCurrentYear(): Promise<AgtLeadNowConsecutiveModel[]> {
		const results = await this.query();
		return results.map(data => new AgtLeadNowConsecutiveModel(data));
	}
}
